import { ComponentType } from "react";
import {
  ThemeConfigFieldSchema,
  ThemeConfigInputType,
} from "../../config/theme-configure";
import { CheckboxInput } from "./CheckboxInput";
import { HexColorInput } from "./HexColorInput";
import { SelectInput } from "./SelectInput";

interface ThemeConfigFieldInputProps {
  value?: string;
  onChange?: (value: string) => void;
  field?: ThemeConfigFieldSchema;
}

export const INPUT_TYPE_REGISTRY: Record<
  ThemeConfigInputType,
  ComponentType<ThemeConfigFieldInputProps>
> = {
  checkboxInput: CheckboxInput,
  hexColorInput: HexColorInput,
  selectInput: SelectInput,
};
